import React, { useState } from "react";
import { Link } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import PopupSearch from "../components/PopupSearch";
import ScrollToTop from "../components/ScrollToTop";

const ShopSidebar = () => {
  const [price, setPrice] = useState(150);
   const [menuOpen, setMenuOpen] =  useState(false);

  const products = [
    {
      id: 1,
      image: "/assets/img/product5/p-s-1-1.png",
      title: "Triumph Watch",
      price: "$755.00",
      isNew: false,
    },
    {
      id: 2,
      image: "/assets/img/product5/p-s-1-2.png",
      title: "Golden Line",
      price: "$955.00",
      isNew: true,
    },
    {
      id: 3,
      image: "/assets/img/product5/p-s-1-3.png",
      title: "Round Dial Semi",
      price: "$555.00",
      isNew: false,
    },
    {
      id: 4,
      image: "/assets/img/product5/p-s-1-4.png",
      title: "Black Dial Red",
      price: "$355.00",
      isNew: false,
    },
    {
      id: 5,
      image: "/assets/img/product5/p-s-1-5.png",
      title: "Golden Line",
      price: "$955.00",
      isNew: true,
    },
    {
      id: 6,
      image: "/assets/img/product5/p-s-1-6.png",
      title: "Round Dial Semi",
      price: "$555.00",
      isNew: false,
    },
  ];

  return (
    <>
      <MobileMenu
  isOpen={menuOpen}
  onClose={() => setMenuOpen(false)}
/>
      <PopupSearch />

      <main className="main">
        <Header />
<link rel="stylesheet" href="/assets/css/About.css" />
        {/* Breadcrumb */}
        <div
          className="breadcumb-wrapper"
          style={{
            backgroundImage:
              "url('/assets/img/bg/breadcumb-bg-2.jpg')",
                  backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
          }}
        >
          <img
            src="/assets/img/shapes/dot-shape.svg"
            alt="dot"
            className="breadcumb-element"
          />

          <div className="container z-index-common">
            <div className="breadcumb-content">
              <h1 className="breadcumb-title">
                New Arrivals
              </h1>

              <div className="breadcumb-menu-wrap">
                <ul className="breadcumb-menu">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>Our Shop</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Product Section */}
        <section className="shop-page1 space-top space-extra-bottom z-index-common">
          <div className="extra-shape"></div>

          <div className="container">
            <div className="row">

              {/* Sidebar */}
              <div className="col-xl-3 col-lg-4">
                <aside className="shop-sidebar">

                  {/* Price Filter */}
                  <div className="widget">
                    <h3 className="widget_title">
                      Filter By
                    </h3>


<div className="title-section">
  <i className="fa-solid fa-bars-staggered"></i>
  <div className="price-heading">Price</div>
</div>

                    <div className="range-slider-area">
<input
  type="range"
  min="20"
  max="100"
  value={price}
  className="range-slider-custom"
  style={{
    background: `linear-gradient(
      to right,
      #b8400e 0%,
      #b8400e ${((price - 20) / (100 - 20)) * 100}%,
      #e8d9c5 ${((price - 20) / (100 - 20)) * 100}%,
      #e8d9c5 100%
    )`,
  }}
  onChange={(e) => setPrice(Number(e.target.value))}
/>

                      <div className="slider-btn mt-3">
                        <button className="filter-btn vs-btn">
                          Filter
                        </button>

                        <div className="slider-amount">
                          Price : $30 - ${price}
                        </div>
                      </div>

                      <button className="reset-btn">
                        Clear All
                      </button>
                    </div>
                  </div>

                  {/* Category */}
                  <div className="widget">
                    <h3 className="widget_title">
                      Category
                    </h3>

                    <div className="category-filter">
                    <ul>
  <li className="category-item">
    <input
      type="checkbox"
      className="category-checkbox"
      defaultChecked
    />
    Diamond Watch
    <span>05</span>
  </li>

  <li className="category-item">
    <input
      type="checkbox"
      className="category-checkbox"
    />
    Woman Watch
    <span>08</span>
  </li>

  <li className="category-item">
    <input
      type="checkbox"
      className="category-checkbox"
    />
    Pendant
    <span>14</span>
  </li>
</ul>
                    </div>
                  </div>

                  {/* Latest Products */}
                  <div className="widget">
                    <h3 className="widget_title">
                      Latest Products
                    </h3>

                    {[1, 2, 3].map((item) => (
                      <div
                        className="latest-product"
                        key={item}
                      >
                        <div className="media-img">
                          <img
                            src={`/assets/img/products5/product-1-${item}.png`}
                            alt=""
                          />
                        </div>

                        <div className="media-body">
                          <h4 className="product-title">
                            Diamond Ring
                          </h4>

                          <p className="product-price">
                            $30.00
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Instagram */}
                  <div className="widget">
                    <h4 className="widget_title">
                      Instagram
                    </h4>

                    <div className="sidebar-gallery">
                      {[1, 2, 3, 4].map((img) => (
                        <div
                          className="gallery-thumb"
                          key={img}
                        >
                          <img
                            src={`/assets/img/widget/gal-s-1-${img}.jpg`}
                            alt=""
                            className="w-100"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </aside>
              </div>

              {/* Products */}
              <div className="col-xl-9 col-lg-8">

                {/* Sort Bar */}
                <div className="vs-sort-bar style2">
                  <div className="row gx-4 gy-4 align-items-center">
                    <div className="col-md-auto flex-grow-1">
                      <p className="woocommerce-result-count">
                        <span>||</span>
                        Showing 1 - 09 of 20 results
                      </p>
                    </div>

                    <div className="col-md-auto">
                      <select className="orderby">
                        <option>
                          Sort by top rating
                        </option>
                        <option>
                          Sort by popularity
                        </option>
                        <option>
                          Sort by latest
                        </option>
                        <option>
                          Price low to high
                        </option>
                        <option>
                          Price high to low
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Product Grid */}
                <div className="row">
                  
                  {products.map((product) => (
                    <div
                      className="col-xl-4 col-lg-6 col-md-6"
                      key={product.id}
                    >
                      
                      <div className="product-style2 version3">

                        <div className="product-action">
                       <button className="product-action__btn">
  <i className="fa-regular fa-heart"></i>
</button>

<button className="product-action__btn">
  <i className="fa-regular fa-eye"></i>
</button>
                        </div>

                        {product.isNew && (
                          <span className="product-tag">
                            New
                          </span>
                        )}

                        <div className="product-img">
                          <img
                            className="img"
                            src={product.image}
                            alt={product.title}
                          />
                        </div>

                        <h3 className="product-title">
                          <Link to="/shop-details">
                            {product.title}
                          </Link>
                        </h3>

                        <span className="product-price">
                          <span className="product-price__number">
                            {product.price}
                          </span>

                          <button className="product-cart">
                            Add To Cart
                          </button>
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
 

              </div>
            </div>
          </div>
        </section>

        <Footer />
      </main>

      <ScrollToTop />
    </>
  );
};

export default ShopSidebar;